// redux
import store from '../../redux/store';

const canEditBranchNamePermission = (
  {is_superuser = false} = store.getState().authorization.userData
) => is_superuser;

export default canEditBranchNamePermission;
